"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fontConfig = {
    cdnBaseUrl: {
        development: 'https://assets.fastly.zagforward.com',
        test: 'https://assets.fastly.carvanatech.com',
        uat: 'https://resources.fastly.cvuat.com',
        prod: 'https://assets.fastly.carvana.io',
        production: 'https://assets.fastly.carvana.io'
    }
};
exports.default = fontConfig;
